/**
 * Returns true if a DOM event targeted a link (anchor) or its children.
 * Use in AG Grid onRowClicked / onCellMouseDown to skip the row's
 * open-transcript navigation when an in-cell link (e.g. the Timeline link)
 * was clicked, so the link's own navigation wins.
 *
 * AG Grid's row/cell click events are its own, not DOM bubbling, so a React
 * `stopPropagation` on the link can't prevent them; this guard is how the grid
 * itself opts out.
 */
export function isLinkClick(event: { event?: Event | null }): boolean {
  const target = event.event?.target;
  if (!(target instanceof Element)) return false;
  return !!target.closest('a');
}
